import {
  createComponentPreviewMapperModel,
  withCompPreviewProps,
} from '@wix/editor-elements-integrations';
import type {
  FreemiumBannerDesktopDefinition,
  FreemiumBannerDesktopPlatformProps,
} from '../FreemiumBannerDesktop.types';
import previewTranslationKeys from './constants.preview';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import { freemiumBannerExperiments } from '../../common/constants';
import concatQueryParamsToUrl from '../../common/concatQueryParamsToUrl';

export const props = withCompPreviewProps<
  FreemiumBannerDesktopPlatformProps,
  FreemiumBannerDesktopDefinition
>()(
  ['direction', 'metaSiteId', 'translate', 'experiments'],
  ({ translate, direction, metaSiteId, experiments }) => {
    const isNewLogo = isExperimentOpen(
      experiments,
      freemiumBannerExperiments.newBannerDesktop,
    );

    const href = isNewLogo
      ? translate(
          previewTranslationKeys.NAMESPACE,
          previewTranslationKeys.HREF_KEY_NEW,
        ) || previewTranslationKeys.HREF_KEY_DEFAULT
      : translate(
          previewTranslationKeys.NAMESPACE,
          previewTranslationKeys.HREF_KEY_OLD,
        ) || previewTranslationKeys.HREF_KEY_DEFAULT;

    const hrefAdsVersion = isNewLogo ? 'banner_2024_preview' : '';

    const hrefWithQueryParams = concatQueryParamsToUrl(href, {
      orig_msid: metaSiteId,
      adsVersion: hrefAdsVersion,
    });

    return {
      useOverlay: false,
      direction,
      classNames: [direction],
      translations: {
        bannerText:
          translate(
            previewTranslationKeys.NAMESPACE,
            previewTranslationKeys.MAIN_TEXT_KEY,
          ) ||
          previewTranslationKeys.MAIN_TEXT_DEFAULT ||
          '',
        buttonText:
          translate(
            previewTranslationKeys.NAMESPACE,
            previewTranslationKeys.BUTTON_TEXT_KEY,
          ) || previewTranslationKeys.BUTTON_TEXT_DEFAULT,
      },
      href: hrefWithQueryParams,
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
